module.exports = __webpack_public_path__ + "static/media/app-screenshot-2.59bf8311.png";